import createReducer from 'store/createReducer';
import * as types from './types';
import * as profileTypes from '../../profile/redux-sagas/types';

const initialState = {
  values: {
    0: {},
    1: {},
    2: {},
    3: {},
  },
  aux: {},
  complate: {
    0: false,
    1: false,
    2: false,
    3: false,
  },
};

const PorcessComplateReducer = createReducer(initialState, {
  [types.SET_VALUES](state, action) {
    return {
      ...state,
      values: {
        ...state.values,
        [action.payload.step]: {
          ...state.values?.[action.payload.step],
          ...action.payload.values,
        },
      },
      aux: {
        ...state.aux,
        ...action.payload.aux,
      },
      complate: {
        ...state.complate,
        ...action.payload.complate,
      },
    };
  },
  [profileTypes.SIGN_OUT](state, action) {
    return {
      ...initialState,
    };
  },
});

export default PorcessComplateReducer;
